import { CONNECTION_ERROR } from '../BasePage'

import * as AbstractValidation from '../../libs/validation/remoteValidationAbstract'
import * as StringValidation from '../../libs/validation/stringRegex'
import * as Constants from '../../costants'

import { isNotValidScadenzaPolizza } from '../../libs/validation/dateValidation'
import { isValidPrivacy } from '../../components/privacy/BasicPrivacy'
import { isAfterCurrentYear } from '../../libs/validation/dateValidation'

import { authFetch } from '../../libs/cookie/Cookie'

import { UserType } from '../../libs/user/User'

export function plateValidation (
    value: string,
    koCallBack: Function
) {
    AbstractValidation.valueValidation(
        Constants.SHIP_PLATE_VALIDATION_URL,
        value,
        AbstractValidation.voidFunction,
        koCallBack
    )
}

export function powerValidation (
    c: number | undefined,
    k: number | undefined,
    koCallBack: Function
) {
    const value = {
        cavalli: c,
        kw: k
    }

    AbstractValidation.valueValidation(
        Constants.POWER_VALIDATION_URL,
        value,
        AbstractValidation.voidFunction,
        koCallBack
    )
}

export async function pageTwoValidation (
    altriSinistri: boolean | undefined,
    polizzaAttiva: boolean | undefined,
    scadenzaPolizza: string | undefined,
    tipoPolizza: string | undefined,
    lunghezza: number | undefined,
    peso: number | undefined,
    targa: string | undefined,
    nome: string | undefined,
    porto: string | undefined,
    costruttore: string | undefined,
    trasportati: number | undefined,

    printErrorCallBack: Function,
    manageExpiredSessionsCallBack: Function
) {
    let error = undefined

    if (altriSinistri === undefined) {
        error = 'SINISTRI'
    }
    else if (polizzaAttiva === undefined) {
        error = 'POLIZZA'
    }
    else if (
        polizzaAttiva === true && 
        isNotValidScadenzaPolizza(scadenzaPolizza)
    ) {
        error = 'SCADENZA_POLIZZA'
    }
    else if (StringValidation.isEmpty(tipoPolizza)) {
        error = 'TIPOPOLIZZA'
    }
    else if (tipoPolizza !== 'soloMotore') {
        if (lunghezza === undefined || Number(lunghezza) < 1) {
            error = 'LUNGHEZZA'
        }
        else if (peso === undefined || Number(peso) < 0.01) {
            error = 'PESO'
        }
        else if (targa === undefined || targa.length < 6) {
            error = 'TARGA'
        }
        else if (StringValidation.isEmpty( nome )) {
            error = 'NOME'
        }
        else if (StringValidation.isEmpty( porto )) {
            error = 'PORTO'
        }
        else if (StringValidation.isEmpty( costruttore )) {
            error = 'COSTRUTTORE'
        }
        else if (trasportati === undefined || Number(trasportati) < 1) {
            error = 'TRASPORTATI'
        }
        else {
            await authFetch (
                Constants.STEP_2_VALIDATION_URL,
                {
                    method: "post",
                    body: JSON.stringify({
                        Claims_In_Past: altriSinistri ?? null,
                        Policy_Already_Exists: polizzaAttiva ?? null,
                        Policy_Expire_At: scadenzaPolizza ?? null,
                        Boat_Category: tipoPolizza ?? null,
                        Boat_Length: lunghezza ?? null,
                        Boat_Weight: peso ?? null,
                        Boat_Plate: targa ?? null,
                        Boat_Name: nome ?? null,
                        Boat_Station_Port: porto ?? null,
                        Boat_Builder_Name: costruttore ?? null,
                        Boat_Max_Passengers: trasportati ?? null
                    })
                },
                manageExpiredSessionsCallBack,
            ).then ( jsonObj => {
                if (jsonObj.status > 200) {
                    error = jsonObj.msg ?? "Impossibile salvare la richiesta, riporva più tardi."
                }
            }).catch( error => {
                error = CONNECTION_ERROR
            })
        }
    }

    printErrorCallBack (error)

    return error
}

export async function pageThreeValidation (
    kw: number | undefined,
    cavalli: number | undefined,
    matricola: string | undefined,
    anno: number | undefined,
    alimentazione: string | undefined,
    marca: string | undefined,
    ormeggio: string | undefined,
    utilizzo: string | undefined,

    user: UserType | undefined,
    noMotorPrivacy: any,

    printErrorCallBack: Function,
    manageExpiredSessionsCallBack: Function
) {
    let error = undefined

    if (kw === undefined || Number(kw) < 1) {
        error = 'KW'
    }
    else if (cavalli === undefined || Number(cavalli) < 1) {
        error = 'CAVALLI'
    }
    else if (matricola === undefined || matricola.length < 6) {
        error = 'MATRICOLA'
    }
    else if (anno === undefined || Number(anno) < 1 || isAfterCurrentYear(anno)) {
        error = 'ANNO'
    }
    else if (StringValidation.isEmpty( alimentazione )) {
        error = 'ALIMENTAZIONE'
    }
    else if (StringValidation.isEmpty( marca )) {
        error = 'BRAND'
    }
    else if (StringValidation.isEmpty( ormeggio )) {
        error = 'ORMEGGIO'
    }
    else if (StringValidation.isEmpty( utilizzo )) {
        error = 'UTILIZZO'
    }
    else if (isValidPrivacy( noMotorPrivacy, user !== undefined)) {
        error = 'PRIVACY'
    }
    else {
        await authFetch (
            Constants.STEP_3_VALIDATION_URL,
            {
                method: "post",
                body: JSON.stringify({
                    Boat_kW: kw,
                    Boat_Fiscal_Power: cavalli,
                    Boat_Engine_Serial_Number: matricola,
                    Boat_Engine_Construction_Year: anno,
                    Boat_Engine_Supply: alimentazione,
                    Boat_Brand: marca,
                    Boat_Station_Region: ormeggio,
                    Boat_Main_Usage: utilizzo,
                    isLogged: (user !== undefined),
                    privacy: noMotorPrivacy
                })
            },
            manageExpiredSessionsCallBack,
        ).then ( jsonObj => {
            if (jsonObj.status > 200) {
                error = jsonObj.msg ?? "Impossibile salvare la richiesta, riporva più tardi."
            }
        }).catch( error => {
            error = CONNECTION_ERROR
        })
    }

    printErrorCallBack (error)

    return error
}